import React, { useEffect } from 'react';

// Socle visuel commun aux formulaires et aux modales.
// Une seule définition ici évite que les écrans dérivent les uns des autres.

export const fieldClass =
  'w-full px-4 py-3 bg-surface border border-sand-300 rounded-xl text-ink-900 ' +
  'placeholder:text-ink-400 outline-none transition-colors ' +
  'focus:border-clay-500 focus:ring-2 focus:ring-clay-500/20';

export const btnPrimary =
  'px-5 py-3 bg-clay-500 text-onAccent rounded-xl font-medium ' +
  'hover:bg-clay-600 disabled:bg-sand-300 transition-colors';

export const btnGhost =
  'px-5 py-3 border border-sand-300 rounded-xl text-ink-700 ' +
  'hover:border-ink-400 disabled:text-ink-400 transition-colors';

export const Field = ({ label, hint, children }) => (
  <div>
    <label className="label-caps block mb-2">{label}</label>
    {children}
    {hint && <p className="text-xs text-ink-400 mt-1.5">{hint}</p>}
  </div>
);

/**
 * Coquille de modale : voile, panneau centré, en-tête collant.
 * Ferme sur Échap et sur clic dans le voile.
 */
export const Modal = ({ isOpen, onClose, title, subtitle, children }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    // Empêche la page derrière de défiler pendant que la modale est ouverte
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = previous;
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center
                 bg-black/70 backdrop-blur-sm p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className="bg-surface w-full sm:max-w-lg max-h-[92vh] overflow-y-auto
                   rounded-t-2xl sm:rounded-2xl shadow-lift"
      >
        <div className="sticky top-0 bg-surface/95 backdrop-blur border-b border-sand-200
                        px-6 pt-6 pb-4 flex items-start justify-between gap-4">
          <div>
            <h2 className="font-display text-2xl leading-none text-ink-900">{title}</h2>
            {subtitle && <p className="label-caps mt-2">{subtitle}</p>}
          </div>
          <button
            onClick={onClose}
            className="-mr-1.5 p-1.5 text-ink-400 hover:text-ink-900 transition-colors"
            aria-label="Fermer"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.75} viewBox="0 0 24 24">
              <path strokeLinecap="round" d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        </div>

        <div className="px-6 py-6">{children}</div>
      </div>
    </div>
  );
};
